import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  MobileDetectService,
  UserModel,
} from '@lib/gc-common';

@Component({
  selector: 'mip-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss'],
})
export class ProfileHeaderComponent implements OnInit {
  @Input() profile: UserModel = null;

  totalCharacters = 75;
  expandBio = false;
  isMobile = true;
  isDesktop = false;

  constructor(private mobileDetectService: MobileDetectService) {
    this.isMobile = this.mobileDetectService.isMobile();
    this.isDesktop = !this.mobileDetectService.isMobile();

    if (this.isDesktop) {
      this.totalCharacters = 150;
    }
  }

  async ngOnInit() {
    try {
      // console.log('profile-header.component->ngOnInit(): this.profile', this.profile);
    } catch (e) {
      throw e;
    }
  }
}
